import { writable } from 'svelte/store'

//------APP STATE---------
export const apiUrl = "https://6986daee.jp-tok.apigw.appdomain.cloud/sequ-health-pro-client"

export const token = writable(localStorage.getItem("token") || "")
token.subscribe(val => localStorage.setItem("token", val));

export const decMade = writable(localStorage.getItem("decMade") || "")
decMade.subscribe(val => localStorage.setItem("decMade", val))

export const feverDetected = writable(localStorage.getItem("feverDetected") || "")
feverDetected.subscribe(val => localStorage.setItem("feverDetected", val))

//------COMPANY INFORMATION---------
export const cloudant_id = writable(localStorage.getItem("cloudant_id") || "")
cloudant_id.subscribe(val => localStorage.setItem("cloudant_id", val));

export const corp_id = writable(localStorage.getItem("corp_id") || "")
corp_id.subscribe(val => localStorage.setItem("corp_id", val))

export const corp_name = writable(localStorage.getItem("corp_name") || "")
corp_name.subscribe(val => localStorage.setItem("corp_name", val))

export const corp_uname = writable(localStorage.getItem("corp_uname") || "")
corp_uname.subscribe(val => localStorage.setItem("corp_uname", val))

export const corp_emails = writable(localStorage.getItem("corp_emails") || "")
corp_emails.subscribe(val => localStorage.setItem("corp_emails", val))

export const region = writable(localStorage.getItem("region") || "")
region.subscribe(val => localStorage.setItem("region", val))

export const primaryColor = writable(localStorage.getItem("primaryColor") || "#1600ff")
primaryColor.subscribe(val => localStorage.setItem("primaryColor", val))

export const headerColor = writable(localStorage.getItem("headerColor") || "#161616")
headerColor.subscribe(val => localStorage.setItem("headerColor", val))

export const addQuestions = writable(localStorage.getItem("addQuestions") || JSON.stringify(''))
addQuestions.subscribe(val => localStorage.setItem("addQuestions", val))

//------PERSONAL INFORMATION---------
export const name = writable(localStorage.getItem("name") || "")
name.subscribe(val => localStorage.setItem("name", val));

export const sex = writable(localStorage.getItem("sex") || "")
sex.subscribe(val => localStorage.setItem("sex", val));

export const age = writable(localStorage.getItem("age") || "")
age.subscribe(val => localStorage.setItem("age", val));

export const residence = writable(localStorage.getItem("residence") || "")
residence.subscribe(val => localStorage.setItem("residence", val));

export const cellphone = writable(localStorage.getItem("cellphone") || "")
cellphone.subscribe(val => localStorage.setItem("cellphone", val));

export const idNumber = writable(localStorage.getItem("idNumber") || "")
idNumber.subscribe(val => localStorage.setItem("idNumber", val));

export const department = writable(localStorage.getItem("department") || "")
department.subscribe(val => localStorage.setItem("department", val));

export const soreThroat = writable(localStorage.getItem("soreThroat") || "")
soreThroat.subscribe(val => localStorage.setItem("soreThroat", val));

export const bodyPains = writable(localStorage.getItem("bodyPains") || "")
bodyPains.subscribe(val => localStorage.setItem("bodyPains", val));

export const headache = writable(localStorage.getItem("headache") || "")
headache.subscribe(val => localStorage.setItem("headache", val));

export const fever = writable(localStorage.getItem("fever") || "")
fever.subscribe(val => localStorage.setItem("fever", val));

export const covidContact = writable(localStorage.getItem("covidContact") || "")
covidContact.subscribe(val => localStorage.setItem("covidContact", val));

export const supsectContact = writable(localStorage.getItem("supsectContact") || "")
supsectContact.subscribe(val => localStorage.setItem("supsectContact", val));

export const travelAbroad = writable(localStorage.getItem("travelAbroad") || "")
travelAbroad.subscribe(val => localStorage.setItem("travelAbroad", val));

export const travelCity = writable(localStorage.getItem("travelCity") || "NO")
travelCity.subscribe(val => localStorage.setItem("travelCity", val));

export const triage = writable(localStorage.getItem("triage") || "")
triage.subscribe(val => localStorage.setItem("triage", val));

export const triageDesc = writable(localStorage.getItem("triageDesc") || "")
triageDesc.subscribe(val => localStorage.setItem("triageDesc", val));

export const time = writable(localStorage.getItem("time") || "")
time.subscribe(val => localStorage.setItem("time", val));

export const temp = writable(localStorage.getItem("temp") || "")
temp.subscribe(val => localStorage.setItem("temp", val));

export const addQuestionsAns = writable(localStorage.getItem("addQuestionsAns") || JSON.stringify(''))
addQuestionsAns.subscribe(val => localStorage.setItem("addQuestionsAns", val))